import * as React from 'react';
import { scienceBlue } from '../abstracts/colours';

export interface IconProps {
  fill?: string;
}

const Copy: React.SFC<IconProps> = ({ fill = scienceBlue }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H48V48H0z" />
        <g transform="translate(6 11)">
          <rect width="23" height="17" x=".5" y="8.5" stroke={fill} rx="2" />
          <rect width="24" height="18" x="12" fill={fill} rx="2" />
        </g>
      </g>
    </svg>
  );
};

export default Copy;
